import { createActionsCreator } from '../actionCreatorsFactory'

const createAction = createActionsCreator('SAGAS/NOTIFICATIONS')

export const showError = createAction('SHOW_ERROR')
export const showMessage = createAction('SHOW_MESSAGE')
export const showWarning = createAction('SHOW_WARNING')
